import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationStep } from 'embed/constants'
import { StepbystepCreditApplicationWrapper } from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchReturnToOriginalStep: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  shouldDisplayBackToSearch: boolean
  stepByStepApplicationStep: ApplicationStep | undefined
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

export const StepbystepApplicationStepEmail: React.FC<Props> = (props) => (
  <StepbystepCreditApplicationWrapper {...props}>
    <StepTitle>What’s your email?</StepTitle>
    <ApplicationField
      product={Product.CreditCard}
      field={Fields.EmailAddress}
      forceFocus={true}
      onEnter={props.onEnter}
    />
  </StepbystepCreditApplicationWrapper>
)
